import { FC, useCallback } from 'react';
import styled, { useTheme } from "styled-components";
import { Colors, FlexBox, MagicBox } from "@brg/ui";
import { bTag, useModal } from "../../../core";
import { TagsSearchResultsTitle, TagsSearchTitle, HeaderTagRoot } from "./styles.mobile";
import { TagItemViewTextWrapper } from "../../../core/components/bTag/styles";
import { ArrowCornerSvg } from "../../assets/24/ArrowCornerSvg";
import { useDispatch, useSelector } from "react-redux";
import ICArrowLef32 from "../../assets/32/ICArrowLeftLarge32";
import { TagsActions } from "../../reducers/Tags";
import { useHistory } from 'react-router-dom';
import { CreateLinkTo } from 'shared/constants/linkTo';

export const LABORATORY_PARAM = '?_lab';

export interface CategoryHeaderProps {
  headerTag: any;
}

export const LevelOneTitle = styled(TagItemViewTextWrapper)`
  margin: 0 0 0 0 !important;
  border-color: ${Colors.galBlack61};
  color: ${Colors.galBlack100};
  &:before {
    display: none !important;
  }
`

const LevelTwoTitle = styled(FlexBox)`
  svg path {
    fill: ${({ theme}) => theme.tagSearch.subtitleColor} !important;
  }
`

export const CategoryHeader: FC<CategoryHeaderProps> = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const history = useHistory();
  const modal = useModal();
  const headerTag = useSelector((state: any) => state.tags.headerTag);
  const isEditProjectPage = window.location.pathname.startsWith('/edit');
  const isLaboratoryPage = window?.location.pathname.startsWith('/laboratory') || Boolean(window.location.href.split('?').find((l) => l === LABORATORY_PARAM.slice(1)));
  const handleBackClick = () => {
    dispatch(TagsActions.setHeaderTag({
      current: headerTag.parent,
      parent: null
    }));
  }

  const handleSetUrlClick = useCallback((id: string): void => {
    if (id) {
        if (isLaboratoryPage) {

            history.push(CreateLinkTo.tag(id + '/?_lab'))
        } else {
            history.push(CreateLinkTo.tag(id))
        }
        modal.hide();
    }
}, [isLaboratoryPage, history, modal])


  const title = bTag.title(headerTag.current)
  const { level } = headerTag?.current;

  return (
    <HeaderTagRoot align="center" justify="space-between" height={41}>
      <MagicBox align={'center'} onClick={handleBackClick}>
        <ICArrowLef32 fill={theme.tags.modal.search.color}/>
      </MagicBox>
      <TagsSearchTitle color={theme.tagSearch.titleColor}>
        <FlexBox align="center">
          {level === 1 && (
            <LevelOneTitle parent>
              {title}
            </LevelOneTitle>
          )}
          {level === 2 && (
            <LevelTwoTitle>
              <TagsSearchResultsTitle>
                {title}
              </TagsSearchResultsTitle>
              {headerTag.current?.isTagCategory && !isEditProjectPage && (
                <MagicBox offsetLeft={4} align={'center'} onClick={() => handleSetUrlClick(headerTag.current?.tagId)}>
                  <ArrowCornerSvg clr={theme.tagSearch.subtitleColor} opacity={'1'}/>
                </MagicBox>
              )}
            </LevelTwoTitle>
          )}
        </FlexBox>
      </TagsSearchTitle>
      <MagicBox width={32}/>
    </HeaderTagRoot>
  );
};
import { FC, useCallback } from 'react';
import styled, { useTheme } from "styled-components";
import { Colors, FlexBox, MagicBox } from "@brg/ui";
import { bTag, useModal } from "../../../core";
import { TagsSearchResultsTitle, TagsSearchTitle, HeaderTagRoot } from "./styles.mobile";
import { TagItemViewTextWrapper } from "../../../core/components/bTag/styles";
import { ArrowCornerSvg } from "../../assets/24/ArrowCornerSvg";
import { useDispatch, useSelector } from "react-redux";
import ICArrowLef32 from "../../assets/32/ICArrowLeftLarge32";
import { TagsActions } from "../../reducers/Tags";
import { useHistory } from 'react-router-dom';
import { CreateLinkTo } from 'shared/constants/linkTo';

export const LABORATORY_PARAM = '?_lab';

export interface CategoryHeaderProps {
  headerTag: any;
}

export const LevelOneTitle = styled(TagItemViewTextWrapper)`
  margin: 0 0 0 0 !important;
  border-color: ${Colors.galBlack61};
  color: ${Colors.galBlack100};
  &:before {
    display: none !important;
  }
`

const LevelTwoTitle = styled(FlexBox)`
  svg path {
    fill: ${({ theme}) => theme.tagSearch.subtitleColor} !important;
  }
`

export const CategoryHeader: FC<CategoryHeaderProps> = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const history = useHistory();
  const modal = useModal();
  const headerTag = useSelector((state: any) => state.tags.headerTag);
  const isEditProjectPage = window.location.pathname.startsWith('/edit');
  const isLaboratoryPage = window?.location.pathname.startsWith('/laboratory') || Boolean(window.location.href.split('?').find((l) => l === LABORATORY_PARAM.slice(1)));
  const handleBackClick = () => {
    dispatch(TagsActions.setHeaderTag({
      current: headerTag.parent,
      parent: null
    }));
  }

  const handleSetUrlClick = useCallback((id: string): void => {
    if (id) {
        if (isLaboratoryPage) {

            history.push(CreateLinkTo.tag(id + '/?_lab'))
        } else {
            history.push(CreateLinkTo.tag(id))
        }
        modal.hide();
    }
}, [isLaboratoryPage, history, modal])


  const title = bTag.title(headerTag.current)
  const { level } = headerTag?.current;

  return (
    <HeaderTagRoot align="center" justify="space-between" height={41}>
      <MagicBox align={'center'} onClick={handleBackClick}>
        <ICArrowLef32 fill={theme.tags.modal.search.color}/>
      </MagicBox>
      <TagsSearchTitle color={theme.tagSearch.titleColor}>
        <FlexBox align="center">
          {level === 1 && (
            <LevelOneTitle parent>
              {title}
            </LevelOneTitle>
          )}
          {level === 2 && (
            <LevelTwoTitle>
              <TagsSearchResultsTitle>
                {title}
              </TagsSearchResultsTitle>
              {headerTag.current?.isTagCategory && !isEditProjectPage && (
                <MagicBox offsetLeft={4} align={'center'} onClick={() => handleSetUrlClick(headerTag.current?.tagId)}>
                  <ArrowCornerSvg clr={theme.tagSearch.subtitleColor} opacity={'1'}/>
                </MagicBox>
              )}
            </LevelTwoTitle>
          )}
        </FlexBox>
      </TagsSearchTitle>
      <MagicBox width={32}/>
    </HeaderTagRoot>
  );
};
